import { IoCardOutline, IoChevronForward, IoDocumentTextOutline, IoEllipsisHorizontal, IoHelpCircleOutline, IoMailOutline, IoPersonAddOutline, IoPersonOutline, IoShirtOutline, IoStorefrontOutline, IoTicketOutline } from "react-icons/io5";
import { FaLine } from "react-icons/fa6";
import { useState } from "react";
import { Post } from '../compornents/Post';
import { lineEnabled, startLineAuth } from '../compornents/LineButton';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Analytics } from '../compornents/Analytics';

export const Account = () => {
  const navigate = useNavigate();
  // メニュー選択
  const selectMenu = (menu) => {
    if (menu === 'profile') {
      // navigate("/profile", { user ,setUser});
      navigate("/profile");
    } else if (menu === 'credit') {
      navigate("/credit");
    } else if (menu === 'cleaning') {
      navigate("/cleaning");
    } else if (menu === 'inquiry') {
      navigate("/inquiry");
    } else if (menu === 'coupon') {
      navigate("/coupon");
    } else if (menu === 'closet') {
      navigate("/closet");
    } else if (menu === 'syokai') {
      navigate("/syokai");
    }else if (menu === 'questionnaire') {
      navigate("/survey");
    } else if (menu === 'help') {
      navigate("/help");
    } else if (menu === 'other') {
      navigate("/other");
    }
  };
  const [lineLinked, setLineLinked] = useState(null); // null=読込中 / ''=未連携 / 表示名=連携済み
  useEffect(() => {
    if (!lineEnabled) return;
    (async () => {
      try {
        const r = await Post('post', '/customer/index.php', {});
        if (r.result === 1) setLineLinked(r.customer?.line_user_id ? (r.customer?.line_display_name || '連携済み') : '');
      } catch (e) { /* 表示のみの情報のため失敗は無視 */ }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="App">
      <div className="Account">
        <Analytics title="アカウント" />
        <div className="mt-3 mb-5">
          <div className="h3 ml-4 mt-4 mb-4 text-left">
            アカウント
          </div>
          <div className="account_list">
            <div className="account div_btn" onClick={() => selectMenu('profile')}>
              <div className="account_icon">
                <IoPersonOutline />
              </div>
              <div className="account_content">
                個人情報
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            {lineEnabled && (
              <div className="account div_btn" onClick={async () => {
                if (lineLinked === '') { startLineAuth('link'); return; }
                if (!lineLinked) return; // 読込中
                // 連携済み → 解除確認（SMS認証ログインは引き続き使えるため安全に解除可能）
                if (!window.confirm(`LINE連携（${lineLinked}）を解除しますか？\n解除するとLINEでのログイン・通知が使えなくなります（SMS認証ログインは引き続きご利用いただけます）。`)) return;
                const r = await Post('post', '/auth/line_unlink.php', {});
                if (r.result === 1) { setLineLinked(''); }
              }}>
                <div className="account_icon" style={{ color: '#06C755' }}>
                  <FaLine />
                </div>
                <div className="account_content">
                  LINE連携
                  {lineLinked === '' && <span style={{ fontSize: 12, color: '#C50018', marginLeft: 8 }}>未連携（タップして連携）</span>}
                  {lineLinked && <span style={{ fontSize: 12, color: '#757575', marginLeft: 8 }}>連携済み（{lineLinked}）・タップで解除</span>}
                </div>
                <div className="account_arrow">
                  <IoChevronForward />
                </div>
              </div>
            )}
            {/* お気に入りクローゼット: 本番は規約改定まで出さない（dev ビルドだけ） */}
            {process.env.REACT_APP_IS_DEV === 'true' && (
              <div className="account div_btn" onClick={() => selectMenu('closet')}>
                <div className="account_icon">
                  <IoShirtOutline />
                </div>
                <div className="account_content">
                  お気に入りクローゼット
                </div>
                <div className="account_arrow">
                  <IoChevronForward />
                </div>
              </div>
            )}
            <div className="account div_btn" onClick={() => selectMenu('coupon')}>
              <div className="account_icon">
                <IoTicketOutline />
              </div>
              <div className="account_content">
                クーポン
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('syokai')}>
              <div className="account_icon">
                <IoPersonAddOutline />
              </div>
              <div className="account_content">
                お友達紹介
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('questionnaire')}>
              <div className="account_icon">
                <IoDocumentTextOutline />
              </div>
              <div className="account_content">
                アンケート
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('credit')}>
              <div className="account_icon">
                <IoCardOutline />
              </div>
              <div className="account_content">
                クレジットカード情報
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('cleaning')}>
              <div className="account_icon">
                <IoStorefrontOutline />
              </div>
              <div className="account_content">
                担当クリーニング店
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('help')}>
              <div className="account_icon">
                <IoHelpCircleOutline />
              </div>
              <div className="account_content">
                ヘルプ
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('inquiry')}>
              <div className="account_icon">
                <IoMailOutline />
              </div>
              <div className="account_content">
                お問い合せ
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="account div_btn" onClick={() => selectMenu('other')}>
              <div className="account_icon">
                <IoEllipsisHorizontal />
              </div>
              <div className="account_content">
                その他
              </div>
              <div className="account_arrow">
                <IoChevronForward />
              </div>
            </div>
          </div>
        </div>
        <Tabbar menu="account" />
      </div>
    </div>
  );
}
